export default __webpack_public_path__ + "static/media/logo_ter_sncf.a08af8c9.svg";